import { useContext } from "react";
import { TimerContext } from "../../../Context/TimerContext";
import convertNumbersToPersian from "../../../Utils/convertNumbersToPersian";

const RemainingTime = ({ Styles }) => {
  const { remainingTimeForRest } = useContext(TimerContext);

  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;

    // تبدیل اعداد انگلیسی به اعداد فارسی
    const persianMinutes = convertNumbersToPersian(minutes.toString());
    const persianSeconds = convertNumbersToPersian(
      seconds < 10 ? "0" + seconds : seconds.toString()
    );

    return `${persianMinutes}:${persianSeconds}`;
  };
  return (
    <div className={Styles.readingContainer}>
      <h2>زمان باقی مانده تا استراحت : {formatTime(remainingTimeForRest)}</h2>
    </div>
  );
};

export default RemainingTime;
